/**
 * Internal dependencies
 */
import getEditedId from './get-edited-id';
import { getLayout } from 'state/dashboard-layouts/selectors';

export default (state) => getLayout(state, getEditedId(state));
